import { useCallback, useMemo,useState } from "react";

export const useDocumentSelection = () => {
  const [selectedDocuments, setSelectedDocuments] = useState({});

  const toggleSelection = useCallback((documentId, document) => {
    setSelectedDocuments((prev) => {
      const newSelected = { ...prev };
      if (newSelected[documentId]) {
        delete newSelected[documentId];
      } else {
        newSelected[documentId] = document;
      }
      return newSelected;
    });
  }, []);

  const selectAll = useCallback((documents) => {
    const allSelected = {};
    documents.forEach((doc) => {
      allSelected[doc.id] = doc;
    });
    setSelectedDocuments(allSelected);
  }, []);

  const deselectAll = useCallback(() => {
    setSelectedDocuments({});
  }, []);

  const isSelected = useCallback((documentId) => {
    return !!selectedDocuments[documentId];
  }, [selectedDocuments]);

  const areAllSelected = useCallback((documents) => {
    if (!documents || documents.length === 0) return false;
    return documents.every((doc) => selectedDocuments[doc.id]);
  }, [selectedDocuments]);

  const selectedCount = useMemo(() => {
    return Object.keys(selectedDocuments).length;
  }, [selectedDocuments]);

  const selectedIds = useMemo(() => {
    return Object.keys(selectedDocuments);
  }, [selectedDocuments]);

  const selectedArray = useMemo(() => {
    return Object.values(selectedDocuments);
  }, [selectedDocuments]);

  return {
    selectedDocuments,
    selectedCount,
    selectedIds,
    selectedArray,
    toggleSelection,
    selectAll,
    deselectAll,
    isSelected,
    areAllSelected,
  };
};
